// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3ILlD","list_item":"styles_list_item__mEOBp","more":"styles_more__2WZHm"};